import Layout from '@/layout';

export default [
  {
    path: '/account',
    name: 'Account',
    redirect: '/account/settings',
    component: Layout,
    meta: {
      title: '账号管理',
      icon: 'icon-account',
    },
    children: [
      {
        path: 'settings',
        name: 'AccountSettings',
        component: () => import('@/views/account/Settings'),
        meta: {
          title: '账号设置',
        },
      },
      {
        path: 'security',
        name: 'AccountSecurity',
        component: () => import('@/views/account/security'),
        meta: {
          title: '账户安全',
        },
      },
      // {
      //   path: 'equity',
      //   name: 'AccountEquity',
      //   component: () => import('@/views/account/Equity'),
      //   meta: {
      //     title: '账号权益',
      //   },
      // },
      {
        path: 'modifyPhone',
        name: 'accModifyPhone',
        component: () => import('@/views/account/modifyPhone'),
        meta: {
          title: '修改手机',
          activePath: 'settings',
        },
        hidden: true,
        children: [
          {
            path: 'newPhone',
            name: 'accNewPhone',
            component: () =>
              import('@/views/account/components/changePhone/newPhone'),
            meta: {
              title: '新号码',
              activePath: 'settings',
            },
            hidden: true,
          },
          {
            path: 'successPhone',
            name: 'accSuccessPhone',
            component: () =>
              import('@/views/account/components/changePhone/successPhone'),
            meta: {
              title: '修改成功',
              activePath: 'settings',
            },
            hidden: true,
          },
        ],
      },
    ],
  },
];
